import { render, staticRenderFns } from "./WebsiteNavigationNestedDropdown.vue?vue&type=template&id=373f8abb"
import script from "./WebsiteNavigationNestedDropdown.vue?vue&type=script&lang=ts"
export * from "./WebsiteNavigationNestedDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports